"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._downloadTemplateTranshipment = exports._uploadProcessTranshipment = exports._uploadDocumentTranshipment = exports._getGridHistoryTranshipment = exports._getGridTranshipment = void 0;
const qs_1 = __importDefault(require("qs"));
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("utils/constants");
const error_response_1 = require("utils/error-response");
const getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
const _getGridTranshipment = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify({
        filters: filter.filters.map(item => {
            if (item.field === 'brand_name' || item.field === 'year') {
                return item;
            }
            else {
                return {
                    field: item.field,
                    operator: 'eq',
                    value: parseInt(item.value)
                };
            }
        }),
        logic: filter.logic
    }) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/bgloading';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridTranshipment = _getGridTranshipment;
const _getGridHistoryTranshipment = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/bgloading-log';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridHistoryTranshipment = _getGridHistoryTranshipment;
const _uploadDocumentTranshipment = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/upload-file';
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.post(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, name: '', countData: 0 };
    }
});
exports._uploadDocumentTranshipment = _uploadDocumentTranshipment;
const _uploadProcessTranshipment = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/bgloading-upload';
    const data = qs_1.default.stringify(payload);
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token(),
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    };
    try {
        const response = yield axios_1.default.post(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, message: '', countData: 0 };
    }
});
exports._uploadProcessTranshipment = _uploadProcessTranshipment;
const _downloadTemplateTranshipment = ({ year }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/planning/bgloading-template';
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    if (year)
        config.params = { year };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, url: '', countData: 0 };
    }
});
exports._downloadTemplateTranshipment = _downloadTemplateTranshipment;
